export const withServiceFeeAlias = <T extends { fees?: number }>(
  payload: T,
): T & { serviceFee?: number } => ({
  ...payload,
  ...(payload.fees !== undefined ? { serviceFee: payload.fees } : {}),
});
